import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRepeat } from '@fortawesome/pro-light-svg-icons'

import { useSetState } from '@domain-group/react-hooks'

import {
  Box, Button, Image, FileInput, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import usePublication, { usePublicationForm } from '@hooks/usePublication'

const defaultState = {
  showImage: false,
}

const UploadPublicationLogoModal = (props) => {
  const { callbacks, modalKey, showModal } = props
  const { closeModal, updatePublication } = callbacks || {}

  const [state, setState] = useSetState(defaultState)
  const { showImage } = state

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, modalKey, {})
  const { publication } = modalPayload

  const logoThumb = digObject(publication, 'logo.thumb')

  useEffect(() => {
    if ((logoThumb)){
      setState({ showImage: true })
    } else {
      setState({ showImage: false })
    }
  }, [publication.id])

  const {
    entityState,
    setEntityState,
  } = usePublicationForm(publication, { validateOn: 'change' })

  const {
    callbacks: { updatePublication: updateFn },
    updating,
  } = usePublication(publication)

  const updatePublicationPayload = {
    callbacks: {
      action: updateFn,
      afterAction: closeModal,
    },
    entityParams: entityState,
    toastText: 'Logo Uploaded',
  }

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={modalKey} showModal={showModal} size="small">
      <SidebarModal.Header callbacks={callbacks} title="Upload" titleSecondLine="Logo" />

      <SidebarModal.Content>
        <Form>
          {!showImage && (
            <Form.Field label="* Upload Logos" marginTop="large">
              <FileInput
                input={{
                  onChange: (fileData, fileObject) => (
                    setEntityState({ logo: fileData, logo_file_name: fileObject.name })
                  ),
                }}
              />
            </Form.Field>
          )}

          {showImage && (
            <>
              <Form.Field label="Image" marginTop="large">
                <Box justifyContent="center">
                  <Image
                    backgroundSize="contain"
                    borderRadius={5}
                    boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
                    height={200}
                    url={logoThumb}
                    width={200}
                  />
                </Box>
              </Form.Field>

              <Form.Field label="More Options" marginTop="large">
                <Button
                  onClick={() => setState({ showImage: false })}
                  buttonStyle="secondaryUtility"
                  icon={<FontAwesomeIcon icon={faRepeat} />}
                  size="medium"
                >
                  Replace Image
                </Button>
              </Form.Field>
            </>
          )}
        </Form>

      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          loading={updating}
          onClick={() => updatePublication(updatePublicationPayload)}
          size="large"
        >
          Save Logo
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

UploadPublicationLogoModal.propTypes = {
  callbacks: PropTypes.object.isRequired,
  modalKey: PropTypes.string,
  showModal: PropTypes.bool,
}

UploadPublicationLogoModal.defaultProps = {
  modalKey: 'UploadPublicationLogoModal',
}

const LazyLoadedModal = props => (
  <SidebarModal.RenderController {...props}>
    <UploadPublicationLogoModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
